import { RIN } from '../types';
export default {
  type: RIN,
  service: 'infura.io-ws',
  url: 'wss://rinkeby.infura.io/ws',
  port: 443,
  auth: false,
  username: '',
  password: ''
};
